import React from "react";
import "../styling/styles.css";

export default function Works() {
    return (
        <div>
            <div class="top-row">
                <div class="row row-cols-1 row-cols-md-2 g-4">
                    <div class="col">
                        <div class="card h-100">
                            <h5 class="card-header">Stocking: The One-Stop Stock Destination</h5>
                            <a href="https://pbyakod.github.io/stocking/"><img src="./stocking.png" class="card-img-top" alt="stocking"></img></a>
                            <div class="card-body">
                                <p class="card-text">This multi-functional website provides users with quick and up-to-date stock information, as well as the latest news around the world. Users who wish to view the stock trend of a particular company can do so at the click of a button, while also catching up on financial updates happening across the economy.</p>
                            </div>
                        </div>
                    </div>
                <div class="col">
                    <div class="card h-100">
                        <h5 class="card-header">Clove: Community Local Organic Vegetable Exchange</h5>
                        <a href="https://still-reef-24172.herokuapp.com/"><img src="./clove.png" class="card-img-top" alt="clove"></img></a>
                        <div class="card-body">
                            <p class="card-text">CLOVE is a community engagement application for backyard gardeners and lovers of fresh local produce. Producers can list their harvests for others to see, and consumers can use the interface to search for local produce. Additionally, you’ll find links to resources that can put you in touch with local charities that accept food donations.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-row">
            <div class="row row-cols-1 row-cols-md-3 g-4">
                <div class="col">
                    <div class="card h-100">
                        <h5 class="card-header">Password Generator</h5>
                        <a href="https://pbyakod.github.io/password-generator/"><img src="./password.png" class="card-img-top" alt="password"></img></a>
                        <div class="card-body">
                            <p class="card-text">A webpage designed to generate random passwords, incase you can't think of one. It creats a string of characters based on various specifications that the user inputs themself, making it unique to every individual.</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100">
                        <h5 class="card-header">Day Planner</h5>
                        <a href="https://pbyakod.github.io/day-planner/"><img src="./dayplan.png" class="card-img-top" alt="dayplan"></img></a>
                        <div class="card-body">
                            <p class="card-text">An interactive scheduler that helps clients maintain their regular working-day tasks. Fun for planning out your long and tedious work days!</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100">
                        <h5 class="card-header">Weather Dashboard</h5>
                        <a href="https://pbyakod.github.io/weather-dashboard/"><img src="./weather.png" class="card-img-top" alt="weather"></img></a>
                        <div class="card-body">
                            <p class="card-text">A webpage that allows users to search the 5-day weather forecast for any city around the world!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}